import "./OverallGauge.css";

// const getOverallGaugeLabel = (score) => {
//   if (score >= 80) return "Strong Bullish";
//   if (score >= 60) return "Bullish";
//   if (score >= 40) return "Neutral";
//   if (score >= 20) return "Bearish";
//   return "Strong Bearish";
// };
//
const getOverallGaugeLabel = (score) => {
  if (score >= 80) return "Strong Bullish";
  if (score >= 60) return "Bullish";
  if (score >= 40) return "Neutral";
  if (score >= 20) return "Bearish";
  return "Strong Bearish";
};

const getGaugeColor = (score) => {
  if (score >= 80) return "#15803d"; // strong green
  if (score >= 60) return "#22c55e"; // green
  if (score >= 40) return "#eab308"; // yellow
  if (score >= 20) return "#f97316"; // orange
  return "#dc2626"; // red
};
const getBgColor = (text) => {
  if (text === "BUY" || text === "Bullish") {
    return "#249966";
  } else if (text === "SELL" || text === "Bearish") {
    return "#dc2626";
  } else {
    return "#fbbf24";
  }
};
export default function OverallScoreGauge({ score = 50 }) {
  const safeScore = Math.max(0, Math.min(100, Number(score || 0)));
  const angle = 180 - (safeScore / 100) * 180;
  const label = getOverallGaugeLabel(safeScore);

  return (
    <div className="overall-gauge">
      <svg viewBox="0 0 220 140" className="overall-gauge-svg">
        <path
          d="M30 110 A80 80 0 0 1 190 110"
          fill="none"
          stroke="#e5e7eb"
          strokeWidth="16"
        />
        <path
          d="M30 110 A80 80 0 0 1 62 46"
          fill="none"
          stroke="#ef4444"
          strokeWidth="16"
        />
        <path
          d="M62 46 A80 80 0 0 1 110 30"
          fill="none"
          stroke="#f97316"
          strokeWidth="16"
        />
        <path
          d="M110 30 A80 80 0 0 1 158 46"
          fill="none"
          stroke="#eab308"
          strokeWidth="16"
        />
        <path
          d="M158 46 A80 80 0 0 1 190 110"
          fill="none"
          stroke="#16a34a"
          strokeWidth="16"
        />

        <line
          x1="110"
          y1="110"
          x2={110 + 65 * Math.cos((Math.PI * angle) / 180)}
          y2={110 - 65 * Math.sin((Math.PI * angle) / 180)}
          stroke="#111827"
          strokeWidth="4"
          strokeLinecap="round"
        />

        <circle cx="110" cy="110" r="6" fill="#111827" />
      </svg>

      <div className="overall-gauge-score">{safeScore}</div>
      <div
        //  className="overall-gauge-label"

        style={{
          background: "none",
          fontSize: "1.2rem",
          fontWeight: "600",
          color: getBgColor(label),
        }}
      >
        {label}
      </div>
    </div>
  );
}
